require('../../modules/es7.string.pad-start');
module.exports = require('../../modules/_core').String.padStart;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/string/pad-start.js
// module id = 3060
// module chunks = 25